module.exports = __webpack_public_path__ + "img/beer_id-91.5938cc54.png";